window.SiteReady(($) => {

  console.log('Init Block: Header Page');

  let $links = $('.header_page_link');

  $links.each((index, el) => {
    let $link = $(el);

    $link.on("mouseover", function (e) {
      if($link.hasClass('fs-checkpoint-active')) {
        $link.removeClass('fs-checkpoint-active');
        setTimeout(() => {
          $link.addClass('fs-checkpoint-active');
        }, 350)
      }
    });
  });

});